// Imports
  // React
  import { useState, useRef } from 'react';
  import { Link } from 'react-router-dom';
  // Firebase
  import { /* signUpFunction, */ signInFunction, useAuth, signOutFunction } from '../firebase/FirebaseClient';
  import ReCAPTCHA from "react-google-recaptcha"
  // Media
  import logo from '../media/logo.png';




// rafce

const Admin = (  ) => {

  // Log In
  const [ email, setEmail ] = useState("");
  const [ password, setPassword ] = useState("");
  const [ loading, setLoading] = useState(false);
  const [ validCaptcha, setValidCaptcha ] = useState(null)
  
  const currentUser = useAuth();


  // Captcha
  const captcha = useRef(null)
  const captchaHandler = () => {
    if(captcha.current.getValue()){
      setValidCaptcha(true)
    }
    else{
      setValidCaptcha(false)
    }
  }


  //Sign Up
  /* const handleSignUp = async () => {
    setLoading(true);
    try{
      await signUpFunction(email, password);
    } catch{
      alert("Error!");
    }  
    setLoading(false)
  } */  

  //Sign In
  const handleSignIn = async () => {
    setLoading(true);
    try{
      await signInFunction(email, password);
    } catch{
      alert("Error!");
    }  
    setLoading(false)
  }  

  //Sign Out
  const handleSignOut = async () => {
    setLoading(true);
    try{
      await signOutFunction()
    } catch{
      alert("Error!");
    }  
    setLoading(false)
  }  




  // Component
  return (
    <div className="banner-admin">
      <div>
        <img className="banner-admin-logo" src={logo} alt="Logo" />
      </div>
      <div>
        { !currentUser ?
          (
          <div className='banner-admin-options'>
            <strong>Bienvenido al panel de administración</strong>
            <form className='banner-admin-form'>
              <input
                className='admin-text-box'
                type="email"
                required
                placeholder="Ingrese su correo electronico..."
                onChange={ (e)=> setEmail(e.target.value) } />
              <input
                className='admin-text-box'
                type="password"
                required
                placeholder="Ingrese su contraseña..."
                onChange={ (e)=> setPassword(e.target.value) } />
              <ReCAPTCHA
                ref={captcha}
                sitekey="6LdiD3QmAAAAAAFWZlG1c5fvXkVTcGHix6ccC7zb"
                onChange={captchaHandler} />
            </form>
            <div>
              {
                validCaptcha === true
                ?
                (
                /* <button className='admin-button' disabled={loading} onClick={handleSignUp}>Crear Nuevo Usuario</button> */
                <button className='admin-button' disabled={loading} onClick={handleSignIn}>Iniciar Sesión</button>
                )
                :
                <p>
                  Por favor, marque la casilla de verificación.<br/>
                  Si no puede verla, refresque la página.
                </p>
              }
            </div>
          </div>
          ) :
          <div className='banner-admin-options'>
            <strong>Bienvenido</strong>
            <span>{ currentUser?.email }</span>
            <Link className="admin-item-button" to="ordenes">Ver Órdenes</Link>
            <Link className="admin-item-button" to="productos">Ver Productos</Link>
            <Link className="admin-item-button" to="combos">Ver Combos</Link>
            <button className='admin-button' disabled={loading} onClick={handleSignOut} value="Iniciar Sesión">Cerrar Sesión</button>
            <Link className='admin-button' to="/tienda/productos">Ir a la Tienda</Link>
          </div>
        }
      </div>
    </div>
  )
  
}

export default Admin

